"use client";

import { createContext, useContext, useEffect, useState, type ReactNode } from "react";
import { usePathname } from "next/navigation";
import { api } from "@/lib/api";

const LearnerContext = createContext<string | null>(null);
export const useLearnerId = () => useContext(LearnerContext);
export default function LearnerProvider({ children }: { children: ReactNode }) {
  const [id, setId] = useState<string | null>(null);
  const path = usePathname();
  useEffect(() => {
    if (path === "/login") return;
    let cancelled = false;
    api
      .me()
      .then((user) => {
        if (!cancelled) setId(user.user_id);
      })
      .catch(() => {
        /* Keep the already authenticated identity during a transient outage. 401 redirects to login. */
      });
    return () => {
      cancelled = true;
    };
  }, [path]);
  return <LearnerContext.Provider value={id}>{children}</LearnerContext.Provider>;
}
